var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.333 20.167L13.4997 20.167",
    stroke: "#141B34",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.333 16.834L16.833 16.834",
    stroke: "#141B34",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.083 17.6673C23.083 20.81 23.083 22.3814 22.0457 23.3577C21.0083 24.334 19.3388 24.334 15.9997 24.334H15.3557C12.6381 24.334 11.2792 24.334 10.3356 23.6691C10.0652 23.4786 9.82516 23.2527 9.62276 22.9982C8.91634 22.1101 8.91634 20.8312 8.91634 18.2734V16.1522C8.91634 13.6829 8.91634 12.4482 9.30712 11.4621C9.93535 9.87684 11.264 8.62639 12.9483 8.03511C13.996 7.66732 15.3079 7.66732 17.9315 7.66732C19.4307 7.66732 20.1803 7.66732 20.779 7.87749C21.7415 8.21536 22.5007 8.9299 22.8597 9.83577C23.083 10.3993 23.083 11.1048 23.083 12.5158V17.6673Z",
    stroke: "#141B34",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.91667 16C8.91667 14.4659 10.1603 13.2222 11.6944 13.2222C12.2493 13.2222 12.9034 13.3194 13.4428 13.1749C13.9221 13.0465 14.2965 12.6721 14.4249 12.1928C14.5694 11.6534 14.4722 10.9993 14.4722 10.4444C14.4722 8.91032 15.7159 7.66667 17.25 7.66667",
    stroke: "#141B34",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentIcon);
export default __webpack_public_path__ + "static/media/document_icon.fed7fd79e59d636c5bee4a6bf980360e.svg";
export { ForwardRef as ReactComponent };